<div class="container High-level-Roadmap">
  <ul ngClass="timeline">
    <li *ngFor="let roadmapSection of roadmapSections" [ngClass]="roadmapSection.position === 'LEFT' ? '' : 'timeline-inverted'">
      <div *ngIf="roadmapSection.heading">
        <div [ngClass]="roadmapSection.heading === '' ? '' : 'timeline-badge dark'">{{ roadmapSection.heading }}</div>
        <br /><br /><br /><br />
      </div>

      <div *ngIf="roadmapSection.group" class="timeline-badge light">{{ roadmapSection.group }}</div>
      <div *ngIf="roadmapSection.group && roadmapSection.category"><br /><br /><br /></div>

      <div *ngIf="roadmapSection.category?.includes('icon')" class="timeline-badge">
        <i class="far fa-calendar-alt icon"></i>
      </div>

      <div class="timeline-panel" [ngClass]="roadmapSection.sectionClass === '' ? '' : roadmapSection.sectionClass">
        <small class="small-title" *ngIf="roadmapSection.subBody" [innerHTML]="roadmapSection.subBody | mdToHtml"> </small>
        <div class="timeline-body">
          <div [innerHTML]="roadmapSection.body | mdToHtml"></div>
        </div>
      </div>
    </li>
  </ul>
</div>
